import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import VerificationPage from "../../../components/VerificationPage";
import {
  creatorSendCode,
  registerCreator,
} from "../../../services/creator/creatorApiFn";
import { encryptPassword, handleOpenSnackBar } from "../../../utils";

const CreatorRegistrationVerification = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { inputValues } = state;
  const [code, setCode] = useState();
  const [isLoading, setIsLoading] = useState("");

  const handleVerify = async () => {
    const payload = {
      profileImage: inputValues.image,
      username: inputValues.name,
      email: inputValues.email,
      phoneNumber: inputValues.phoneNumber,
      creatorType: inputValues.influencerType,
      socialLinks: {
        facebook: inputValues.facebook,
        tiktok: inputValues.tiktok,
        instagram: inputValues.instagram,
      },
      password: encryptPassword(inputValues.password),
      role: "Creator",
      otp: code,
    };

    try {
      setIsLoading(true);
      const response = await registerCreator(payload);
      if (response.data.status === "success") {
        const data = response.data.data;
        navigate("/login", { state: { type: "creator" } });
        handleOpenSnackBar("success", response?.data?.message);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSendCode = async () => {
    try {
      setIsLoading(true);
      const payload = {
        email: inputValues.email,
        purpose: "Registration",
        role: "Creator",
      };
      const response = await creatorSendCode(payload);
      if (response.data.status === "success") {
        handleOpenSnackBar("success", response?.data?.message);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <VerificationPage
      handleBack={() => {
        navigate("/register/creator", { state: { inputValues } });
      }}
      code={code}
      setCode={setCode}
      handleClickBtn={handleVerify}
      isLoading={isLoading}
      handleSendCode={handleSendCode}
    />
  );
};

export default CreatorRegistrationVerification;
